module.exports = __webpack_public_path__ + "img/dinkenclave-12.cd3293ee.jpeg";